// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarSection-cls1_sjk","cls2":"SidebarSection-cls2_48y SidebarSection-cls1_sjk"};